"use client";

import { c as _c } from "react/compiler-runtime";
import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import clsx from "clsx";
interface MemesQuickVoteControlsProps {
  readonly customValue: string;
  readonly drop: ExtendedDrop;
  readonly isCustomOpen: boolean;
  readonly isSubmitting: boolean;
  readonly latestUsedAmount: number | null;
  readonly remainingCount: number;
  readonly quickAmounts: readonly number[];
  readonly uncastPower: number | null;
  readonly votingLabel: string | null;
  readonly onCustomChange: (value: string) => void;
  readonly onCustomSubmit: () => Promise<void>;
  readonly onOpenCustom: () => void;
  readonly onSkip: () => void;
  readonly onVoteAmount: (amount: number) => Promise<void>;
}
export default function MemesQuickVoteControls(t0) {
  const $ = _c(69);
  const {
    customValue,
    drop,
    isCustomOpen,
    isSubmitting,
    latestUsedAmount,
    remainingCount,
    quickAmounts,
    uncastPower,
    votingLabel,
    onCustomChange,
    onCustomSubmit,
    onOpenCustom,
    onSkip,
    onVoteAmount
  } = t0;
  const hasQuickAmounts = quickAmounts.length > 0;
  const title = drop.metadata.find(_temp)?.data_value ?? "Untitled submission";
  const description = drop.metadata.find(_temp2)?.data_value ?? "";
  const authorLabel = drop.author.handle ?? drop.author.primary_address;
  let t1;
  if ($[0] !== customValue) {
    t1 = customValue.trim().length > 0 && Number.parseInt(customValue, 10) > 0 ? formatNumberWithCommas(Number.parseInt(customValue, 10)) : null;
    $[0] = customValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const customAmountLabel = t1;
  let t2;
  if ($[2] !== uncastPower || $[3] !== votingLabel) {
    t2 = typeof uncastPower === "number" && <span className="tw-rounded-full tw-border tw-border-solid tw-border-primary-500/30 tw-bg-primary-500/10 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-primary-300">{formatNumberWithCommas(uncastPower)} {votingLabel ?? "votes"}{" "}left</span>;
    $[2] = uncastPower;
    $[3] = votingLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== remainingCount) {
    t3 = formatNumberWithCommas(remainingCount);
    $[5] = remainingCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="tw-rounded-full tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-iron-300">{t3} left</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-gap-2">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== drop) {
    t6 = <WaveDropAuthorPfp drop={drop} />;
    $[12] = drop;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== authorLabel) {
    t7 = <span className="tw-truncate tw-text-sm tw-font-semibold tw-text-iron-100">{authorLabel}</span>;
    $[14] = authorLabel;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-size-1 tw-flex-shrink-0 tw-rounded-full tw-bg-iron-700" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== drop.created_at) {
    t9 = <span className="tw-text-xs tw-text-iron-500"><WaveDropTime timestamp={drop.created_at} /></span>;
    $[17] = drop.created_at;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-2">{t7}{t8}{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== drop.wave.name) {
    t11 = <p className="tw-mb-0 tw-mt-1 tw-truncate tw-text-xs tw-uppercase tw-tracking-[0.12em] tw-text-iron-500">{drop.wave.name}</p>;
    $[22] = drop.wave.name;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <div className="tw-min-w-0 tw-flex-1">{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t6) {
    t13 = <div className="tw-flex tw-items-center tw-gap-3">{t6}{t12}</div>;
    $[27] = t12;
    $[28] = t6;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== title) {
    t14 = <h2 className="tw-mb-0 tw-mt-4 tw-text-[1.65rem] tw-font-semibold tw-leading-tight tw-text-white">{title}</h2>;
    $[30] = title;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== description) {
    t15 = description && <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-leading-6 tw-text-iron-300" style={{
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 4,
      overflow: "hidden"
    }}>{description}</p>;
    $[32] = description;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <div className="tw-rounded-[1.75rem] tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900/70 tw-p-5">{t13}{t14}{t15}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t5) {
    t17 = <div data-testid="quick-vote-controls-desktop-context" className="tw-hidden tw-flex-col tw-gap-4 md:tw-flex">{t5}{t16}</div>;
    $[38] = t16;
    $[39] = t5;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="tw-min-w-0"><p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.14em] tw-text-iron-500">Quick Vote</p><p className="tw-mb-0 tw-text-sm tw-text-iron-300">Tap once to vote. Skip keeps it for later.</p></div>;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== hasQuickAmounts || $[43] !== isCustomOpen || $[44] !== isSubmitting || $[45] !== latestUsedAmount || $[46] !== onOpenCustom || $[47] !== onVoteAmount || $[48] !== quickAmounts) {
    t19 = hasQuickAmounts && <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-2">{quickAmounts.map(amount => {
        const isLatestUsed = latestUsedAmount === amount;
        return <button key={amount} type="button" onClick={() => {
          onVoteAmount(amount);
        }} disabled={isSubmitting} className={clsx("tw-inline-flex tw-h-12 tw-shrink-0 tw-items-center tw-gap-2 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-solid tw-px-3.5 tw-text-sm tw-font-semibold tw-transition-all", isLatestUsed ? "tw-border-primary-400/50 tw-bg-primary-500/15 tw-text-primary-300" : "tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800", isSubmitting && "tw-cursor-not-allowed tw-opacity-60")}><span>{formatNumberWithCommas(amount)}</span>{isLatestUsed && <span className="tw-rounded-full tw-bg-primary-500/20 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-primary-300">Last used</span>}</button>;
      })}<button type="button" aria-pressed={isCustomOpen} onClick={onOpenCustom} disabled={isSubmitting} className={clsx("tw-inline-flex tw-h-12 tw-shrink-0 tw-items-center tw-gap-3 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-solid tw-px-3.5 tw-text-left tw-text-sm tw-font-semibold tw-transition-all disabled:tw-cursor-not-allowed disabled:tw-opacity-60", isCustomOpen ? "tw-text-primary-200 tw-border-primary-400/50 tw-bg-primary-500/15" : "tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800")}><span className={clsx("tw-inline-flex tw-size-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition-colors", isCustomOpen ? "tw-bg-primary-500/18 tw-text-primary-200 tw-border-primary-400/30" : "tw-border-white/10 tw-bg-black/20 tw-text-iron-400")}><AdjustmentsHorizontalIcon className="tw-size-4" /></span><span>Custom amount</span></button></div>;
    $[42] = hasQuickAmounts;
    $[43] = isCustomOpen;
    $[44] = isSubmitting;
    $[45] = latestUsedAmount;
    $[46] = onOpenCustom;
    $[47] = onVoteAmount;
    $[48] = quickAmounts;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== customAmountLabel || $[51] !== customValue || $[52] !== hasQuickAmounts || $[53] !== isCustomOpen || $[54] !== isSubmitting || $[55] !== onCustomChange || $[56] !== onCustomSubmit || $[57] !== votingLabel) {
    t20 = (!hasQuickAmounts || isCustomOpen) && <div className="tw-rounded-3xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/80 tw-p-4"><div className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-end"><label className="tw-min-w-0 tw-flex-1"><span className="tw-mb-2 tw-block tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-iron-500">Custom amount</span><div className="tw-relative"><input type="text" inputMode="numeric" pattern="[0-9]*" value={customValue} disabled={isSubmitting} onChange={event => onCustomChange(event.target.value)} onKeyDown={event_0 => {
              if (event_0.key !== "Enter") {
                return;
              }
              event_0.preventDefault();
              onCustomSubmit();
            }} className="tw-h-12 tw-w-full tw-rounded-2xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-950 tw-px-4 tw-pr-20 tw-text-base tw-font-semibold tw-text-iron-50 tw-outline-none tw-transition-colors focus:tw-border-primary-400 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-border-iron-500" /><span className="tw-pointer-events-none tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-iron-500">{votingLabel ?? "Votes"}</span></div></label><button type="button" onClick={() => {
          onCustomSubmit();
        }} disabled={isSubmitting} className="tw-inline-flex tw-h-12 tw-shrink-0 tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-2xl tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-5 tw-text-sm tw-font-semibold tw-text-white tw-transition-colors disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-primary-600">{customAmountLabel ? `Vote ${customAmountLabel}` : "Vote"}</button></div></div>;
    $[50] = customAmountLabel;
    $[51] = customValue;
    $[52] = hasQuickAmounts;
    $[53] = isCustomOpen;
    $[54] = isSubmitting;
    $[55] = onCustomChange;
    $[56] = onCustomSubmit;
    $[57] = votingLabel;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== isSubmitting || $[60] !== onSkip) {
    t21 = <button type="button" onClick={onSkip} disabled={isSubmitting} className="tw-inline-flex tw-h-12 tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-5 tw-text-sm tw-font-semibold tw-text-iron-300 tw-transition-colors disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-900">Skip for now</button>;
    $[59] = isSubmitting;
    $[60] = onSkip;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t19 || $[63] !== t20 || $[64] !== t21) {
    t22 = <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-1 md:tw-justify-end">{t18}{t19}{t20}{t21}</div>;
    $[62] = t19;
    $[63] = t20;
    $[64] = t21;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  let t23;
  if ($[66] !== t17 || $[67] !== t22) {
    t23 = <div className="tw-flex tw-flex-col tw-gap-4 md:tw-h-full">{t17}{t22}</div>;
    $[66] = t17;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  return t23;
}
function _temp2(entry_0) {
  return entry_0.data_key === "description";
}
function _temp(entry) {
  return entry.data_key === "title";
}